import { nanoid } from 'nanoid'

/**
 * Generates a fresh, collision-resistant unique id on every call.
 */
export function generateUniqueId() {
    return nanoid()
}

/**
 * Generates a unique id prefixed with the moment it was minted, so an id that outlives
 * the session that made it — a retained impression sitting in local storage — can be
 * read and ordered by when it began.
 */
export function generateTimestampedId() {
    return `${Date.now()}-${generateUniqueId()}`
}
